import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function NoReplyOnOffer({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" colon={false}>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="No reply on offer" />
          </Col>
          <Col span={24}>
            <p>
              If tenant has not responded to the renewal offer do the following.
            </p>
          </Col>
          <Col span={24}>
            <p>
              -make sure their new month to month rate will begin for the coming
              month. (be aware that new leases allow for a $100 per month rate
              going up every 12 months)
            </p>
          </Col>
          <Col span={24}>
            <h3 className="green-info-text">
              Send this email to the tenant through sayeagle
            </h3>
          </Col>
          <Col span={24}>
            <p>
              Your lease renewal has not been signed. We have updated your rate
              to the new month to month rate and will notify the owner of the
              lack of response. If you have any questions please reach out to
              us!
            </p>
          </Col>
          <Col span={24}>
            <h3 className="yellow-info-text">
              Send this email to the owner through sayeagle
            </h3>
          </Col>
          <Col span={24}>
            <p>
              Your tenant at the address above has not signed the lease renewal
              offered to them. I have updated their account to their new month
              to month rate. You now have the following options. Just let me
              know how you would like to proceed.
            </p>
          </Col>
          <Col span={24}>
            <p>1. Leave the tenant at their month to month rate.</p>
          </Col>
          <Col span={24}>
            <p>
              2. Have us issue a non renewal/move out notice to the tenant and
              they will need to vacate in 30 days.
            </p>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default NoReplyOnOffer;
